module.exports = __webpack_public_path__ + "media/audio3.4cfd5ff8.mp3";